import React from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { Icons } from "components";
import "./styles.scss";

class FloatingButton extends React.Component<any, any> {
	render() {
		const { dispatch, user, unreadChatMessages } = this.props;

		if (window.location?.pathname === "/chat" || !user || user?.role !== "user") {
			return null;
		}

		return (
			<button onClick={() => dispatch(push("/chat"))} className="FloatingChatButton">
				{Boolean(unreadChatMessages) && <span className="FloatingChatUnreadMessages" />}
				<Icons.ChatFilled />
			</button>
		);
	}
}

const mapStateToProps = (state: any) => ({
	user: state.user,
	unreadChatMessages: state.unreadChatMessages
});

export default connect(mapStateToProps)(FloatingButton);
